
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare.html",
      function () {
        return require("private-next-pages/compare.html.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare.html"])
      });
    }
  